export const ratios = {
  square: 1,
  landscape1: 0.42,
  landscape2: 0.625,
  portrait1: 1.1,
  portrait2: 1.32,
}

export type MediaRatiosType = keyof typeof ratios
